import moment from 'moment';
import {
  APP_12_HOUR_FORMAT,
  APP_DATE_DAY_MONTH_COMMA_FORMAT,
  APP_DATE_FORMAT_COMMA,
  APP_DATE_MONTH_COMMA_FORMAT,
  APP_FULL_MONTH_DAY_YEAR_FORMAT,
  APP_LOCAL_APPOINTMENT_DATE_FORMAT,
  APP_LOCAL_COMPONENT_DATE_FORMAT,
  APP_LOCAL_DATETIME_FORMAT,
  APP_LOCAL_DATETIME_FORMAT_S,
  APP_LOCAL_DATETIME_FORMAT_Z,
  APP_LOCAL_DATE_FORMAT,
  APP_LOCAL_DATE_FORMAT_APPOINTMENT,
  APP_LOCAL_DATE_MONTH_FORMAT,
  APP_LOCAL_TIME_FORMAT,
  APP_MONTH_DAY_YEAR_FORMAT,
  APP_MONTH_YEAR_FORMAT,
  APP_SERVER_DATE_FORMAT,
  APP_TIME_FORMAT,
  GST_TIME_ZONE
} from './constants';

export const convertDateTimeFromServer = (date) => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeToServer = (date) => (date ? moment(date, APP_LOCAL_DATETIME_FORMAT_Z).toDate() : null);

export const displayDefaultDateTime = () => moment().startOf('day').format(APP_LOCAL_DATETIME_FORMAT);

export const convertDateToServer = (date) => (date ? moment(date).format(APP_SERVER_DATE_FORMAT) : null);

export const convertDateToComponentTime = (date) => (date ? moment(date).format(APP_LOCAL_TIME_FORMAT) : null);

export const convertDateToComponentFieldDate = (date) => (date ? moment(date).format(APP_LOCAL_DATE_FORMAT) : null);

export const convertDateTimeFormat = (date) => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT_S) : null);

export const convertDateToComponentDate = (date) =>
  date ? moment(date).format(APP_LOCAL_COMPONENT_DATE_FORMAT) : null;

export const convertComponentDatePlusOne = (date) =>
  date ? moment(date, APP_LOCAL_COMPONENT_DATE_FORMAT).add(1, 'day').calendar() : null;

export const convertStartDate = (date) => (date ? moment(date).format(APP_LOCAL_DATE_FORMAT_APPOINTMENT) : null);

export const convertDateToAppointmentDate = (date) =>
  date ? moment(date).format(APP_LOCAL_APPOINTMENT_DATE_FORMAT) : null;

export const convertDateToCommaFormat = (date) => (date ? moment(date).format(APP_DATE_FORMAT_COMMA) : null);
export const convertDateToCommaFormatInGst = (date) => (date ? moment(date).utcOffset(GST_TIME_ZONE).format(APP_DATE_FORMAT_COMMA) : null);

export const convertDateToFormatInGst = (date) => (date ? moment(date).utcOffset(GST_TIME_ZONE).format('DD MMM') : null);

export const convertDateToCommaDayMonthFormat = (date) => (date ? moment(date).format(APP_DATE_DAY_MONTH_COMMA_FORMAT) : null);

export const convertDateMonthToCommaFormat = (date) => (date ? moment(date).format(APP_DATE_MONTH_COMMA_FORMAT) : null);

export const convertTimeFormat = (date) => (date ? moment(date).format(APP_TIME_FORMAT) : null);

export const convertMonthYear = (date) => (date ? moment(date).format(APP_MONTH_YEAR_FORMAT) : null);

export const convert24to12HourFormat = (time) => (time ? moment(time).format(APP_12_HOUR_FORMAT) : null);

export const convertUtcToGst = (time) => (time ? moment(time).utcOffset(GST_TIME_ZONE).format(APP_12_HOUR_FORMAT) : null);

export const convertDateToFullCommaFormat = (time) => (time ? moment(time).format(APP_MONTH_DAY_YEAR_FORMAT) : null);

export const convertDateMonthFormat = (time) => (time ? moment(time).format(APP_LOCAL_DATE_MONTH_FORMAT) : null);

export const convertDateTo24HoursFormat = (date) =>
  date ? moment.parseZone(date).local().format(APP_DATE_FORMAT_COMMA) : null;

export const convertDateWithOffset = (date) =>
  date ? moment(date).utcOffset(0).format(APP_LOCAL_DATETIME_FORMAT_S) : null;
export const convertDateNoOffset = (date) => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT_S) : null);

export const getDateDiffrence = (endDate, currentDate) =>
  endDate && currentDate ? moment.duration(moment(endDate).diff(moment(currentDate))) : null;

export const getDateDuration = (date) => {
  const endDate = convertDateWithOffset(new Date(date));
  const currentDate = convertDateNoOffset(new Date());
  return getDateDiffrence(endDate, currentDate);
};

export const getDateDurationFromServer = (date) => {
  const endDate = convertDateTimeFromServer(new Date(date));
  const currentDate = convertDateTimeFromServer(new Date());
  return getDateDiffrence(endDate, currentDate);
};
export const expiryDateTime = (dateTime) => {
    
  const offerExpiry = [];
  const duration = getDateDurationFromServer(dateTime);
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  offerExpiry.push(days, hours, minutes);
  const timeDifferenceInMinutes = offerExpiry[0]*1440 + offerExpiry[1]*60 + offerExpiry[2];
  return timeDifferenceInMinutes;
};


export const convertDateToFullMonthCommaFormat = (time) =>
  time ? moment(time).format(APP_FULL_MONTH_DAY_YEAR_FORMAT) : null;

export const checkHoursDiff = (start, hourRequired) => {
  const startTime = moment(start);
  const endTime = moment(Date.now());
  const duration = moment.duration(startTime.diff(endTime));
  const hours = Math.round(duration.asHours());
  if (!Number?.isNaN(hours) && hours <= hourRequired) {
    return true;
  }
  return false;
};

export const formatDateToDateMonthYear = (inputDate) =>{
  var date = new Date(inputDate);
  var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  var formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
};

export const formatDateToYearMonthDate = (inputDate) => {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const convertTimeToHHMMSS = (inputTime) => {
  const [timePart, period] = (inputTime ?? "").split(' ');
  if (!timePart || !period) {
    return "";
  }
  const [hours, minutes] = timePart.split(':').map(Number);

  let hours24 = hours;
  if (period === 'PM' && hours !== 12) {
    hours24 += 12;
  } else if (period === 'AM' && hours === 12) {
    hours24 = 0;
  };

  const HH = String(hours24).padStart(2, '0');
  const MM = String(minutes).padStart(2, '0');
  const SS = '00'; 

  const formattedTime = `${HH}:${MM}:${SS}`;
  return formattedTime;
};

export const convertMinutesToHHMM = (timeRemaining) => {
  if (Number.isNaN(timeRemaining) || timeRemaining < 0) {
    return '';
  }

  const hours = Math.floor(timeRemaining / 60);
  const minutes = timeRemaining % 60;

  const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

  return formattedHours > 0 ? `${formattedHours}h:${formattedMinutes}min` : `${formattedMinutes}min`;
};

export const formatYearMonthDateTime = (slotTime) => {
  return moment.parseZone(slotTime).local().format(APP_LOCAL_DATETIME_FORMAT_S)
}

export const getDateValue = (data) => {
  const dataValues = data?._data;
  const { years, months, days, hours } = { ...dataValues };
  if (years > 0) {
    return years === 1 ? '1 year ago' : `${years} years ago`;
  }
  if (months > 0) {
    return months === 1 ? '1 month ago' : `${months} months ago`;
  }
  if (days > 0) {
    if (days === 1) {
      return 'Yesterday';
    }
    if (days <= 6) {
      return `${days} days ago`;
    }
    const weeks = Math.floor(days / 7);
    if (weeks === 1) {
      return '1 week ago';
    }
    return `${weeks} weeks ago`;
  }
  if (hours >= 0 && hours < 24) {
    return 'Today';
  }
};

export const getDateDifference = (date) => {
  const currentDate = moment().startOf('day');
  const targetDate = moment(date).startOf('day');
  const diffInDays = targetDate.diff(currentDate, 'days');

    if (diffInDays === 1) {
      return 'Tomorrow';
    }

    if (diffInDays === 0) {
      return 'Today';
    }

    if(diffInDays > 1) {
      return null;
    }

  const absDiffInDays = Math.abs(diffInDays);

  if (absDiffInDays === 1) return 'Yesterday';
  if (absDiffInDays <= 6) return `${absDiffInDays} days ago`;
  
  const diffInWeeks = Math.floor(absDiffInDays / 7);
  if (diffInWeeks === 1) return '1 week ago';
  if (diffInWeeks <= 4) return `${diffInWeeks} weeks ago`;

  const diffInMonths = currentDate.diff(targetDate, 'months');
  if (diffInMonths === 1) return '1 month ago';
  if (diffInMonths < 12) return `${diffInMonths} months ago`;

  const diffInYears = currentDate.diff(targetDate, 'years');
  return diffInYears === 1 ? '1 year ago' : `${diffInYears} years ago`;
};
